import React, {useEffect} from 'react';

import Home from './pages/Home'
import Work from './pages/Work'
import Skills from './pages/Skills'
import Navbar from './components/Navbar'
import ScrollToTop from './components/ScrollToTop';
import CanvasBackground from './components/CanvasBackground';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Projects from './pages/Projects';
import ReactGA from 'react-ga4';
import Contact from './pages/Contact';
function App() {

  useEffect(() => {
    ReactGA.initialize('G-4EZQ64SKJF');
    ReactGA.send({ hitType: "pageview", page: window.location.pathname });
  }, []);

  return (
    <>
      <BrowserRouter>
        <ScrollToTop/>
        <Navbar />
          <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/work" element={<Work />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/skills" element={<Skills />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/projects/:title" element={<Projects />} />
            {/* <Route path="users/:id" element={<Users />} /> */}
          </Routes>
      </BrowserRouter>
       <CanvasBackground />
    </>

  );
}

export default App;
